import S3Analytics from './S3AnalyticsContainer';
import CostBreakdown from './CostBreakdownContainer';
import Reports from './ReportsContainer';
import Resources from './ResourcesContainer';
import ResourcesMap from './ResourcesMapContainer';
import Tags from './TagsContainer';

export default {
  S3Analytics,
  CostBreakdown,
  Reports,
  Resources,
  ResourcesMap,
  Tags
};



// WEBPACK FOOTER //
// ./src/containers/aws/index.js